import React from 'react'

const DefaultLoader = () => (
    <div className={'grid absolute inset-0 bg-transparent-50 default--loader'}>
        <div className={'loading-full-screen flex self-center justify-center'} />
    </div>
)

export default DefaultLoader
